import { FontScaleProvider, ThemeProvider } from '@qi/ui';
import { createRootRoute, Link, Outlet } from '@tanstack/react-router';
import { ErrorBoundary } from '../components/shell/ErrorBoundary.tsx';
import { AuthSync } from '../lib/auth-sync.tsx';
import { FontScaleSync } from '../lib/font-scale-sync.tsx';

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFound,
});

function RootLayout() {
  return (
    <ThemeProvider defaultTheme="dark">
      <FontScaleProvider>
        <AuthSync />
        <FontScaleSync />
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </FontScaleProvider>
    </ThemeProvider>
  );
}

function NotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 text-center">
      <p className="font-mono text-xs uppercase tracking-[0.32em] text-ink-2">404</p>
      <h1 className="font-display text-5xl text-ink-0">Off the map</h1>
      <p className="max-w-md text-ink-1">
        That route is not part of the current resonance protocol.
      </p>
      <Link
        to="/dashboard"
        className="rounded-md border border-hairline-strong px-5 py-2 text-sm text-ink-0 transition-colors hover:bg-surface-3"
      >
        Back to dashboard
      </Link>
    </div>
  );
}
